import { useGLTF } from '@react-three/drei'

var url = './3DModels/Idea_Ch/Idea_Ch.gltf';

export default function Character(props) {
    const { nodes } = useGLTF(url)

    return(
        <>

            <mesh
                scale = {[10.0,10.0,0.9]}
                position={[0.0,-0.175,0.70]}
                rotation={[1.57,0,0.0]}
                geometry={nodes.Cube006.geometry}
         
            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />


            </mesh>


        </>
    )

}

useGLTF.preload(url)

